import React from "react";
import {Accordion, AccordionDetails, Box, List} from "@mui/material";
import {UserAuthItemTypeEnum} from "arteco-api-client-ts";
import {useLocation} from "react-router-dom";
import {ROLE_MAP} from "./components/utils/auth";
import {EmployeeMenu} from "./route_employee";
import {AdminBillingMenu} from "./route_admin_billings";
import {AdminEmployeeMenu} from "./route_admin_employee";
import {AdminRecruitmentMenu} from "./route_admin_recruitment";
import {AdminAccountingMenu} from "./route_admin_accounting";
import {AdminMarketingMenu} from "./route_admin_marketing";
import {ConfigMenu} from "./route_config";
import {AdminComplianceMenu, COMPLIANCE} from "./route_admin_compliance";
import {useLastEvaluation} from "./pages/employee/employee_util";


const SideBar = () => {
	const location = useLocation();
	const [forceEvaluation, setForceEvaluation] = useLastEvaluation();

	const checkIfStart = (role: UserAuthItemTypeEnum): boolean => {
		const roleInfo = ROLE_MAP.get(role);
		if (roleInfo && roleInfo.target) {
			return location.pathname.startsWith(roleInfo.target);
		}
		return false;
	}

	const showEmployee = checkIfStart(UserAuthItemTypeEnum.EMPLOYEE);
	const showAdminBilling = checkIfStart(UserAuthItemTypeEnum.ADMIN_BILLING);
	const showAdminEmployee = checkIfStart(UserAuthItemTypeEnum.ADMIN_EMPLOYEE);
	const showAdminRecruitment = checkIfStart(UserAuthItemTypeEnum.ADMIN_RECRUITMENT);
	const showAdminAccounting = location.pathname.startsWith("/app/admin/accounting");
	const showAdminMarketing = location.pathname.startsWith("/app/admin/marketing");
	const showCompliance = location.pathname.startsWith(COMPLIANCE);
	const showConfig = location.pathname.startsWith("/app/admin/config");

	return (

		<Box px={1}>
			{showEmployee && (
				<Accordion expanded={true}>
					<AccordionDetails>
						<List component={"div"} style={{width: "100%"}}>
							<EmployeeMenu forceEvaluation={forceEvaluation}/>
						</List>
					</AccordionDetails>
				</Accordion>
			)}

			{showAdminBilling && (
				<Accordion expanded={true}>
					<AccordionDetails>
						<List component={"div"} style={{width: "100%"}}>
							<AdminBillingMenu/>
						</List>
					</AccordionDetails>
				</Accordion>
			)}

			{showAdminEmployee && (
				<Accordion expanded={true}>
					<AccordionDetails>
						<List component={"div"} style={{width: "100%"}}>
							<AdminEmployeeMenu/>
						</List>
					</AccordionDetails>
				</Accordion>
			)}

			{showAdminRecruitment && (
				<Accordion expanded={true}>
					<AccordionDetails>
						<List component={"div"} style={{width: "100%"}}>
							<AdminRecruitmentMenu/>
						</List>
					</AccordionDetails>
				</Accordion>
			)}

			{showAdminAccounting && (
				<Accordion expanded={true}>
					<AccordionDetails>
						<List component={"div"} style={{width: "100%"}}>
							<AdminAccountingMenu/>
						</List>
					</AccordionDetails>
				</Accordion>
			)}

			{showAdminMarketing && (
				<Accordion expanded={true}>
					<AccordionDetails>
						<List component={"div"} style={{width: "100%"}}>
							<AdminMarketingMenu/>
						</List>
					</AccordionDetails>
				</Accordion>
			)}

			{showCompliance && (
				<Accordion expanded={true}>
					<AccordionDetails>
						<List component={"div"} style={{width: "100%"}}>
							<AdminComplianceMenu/>
						</List>
					</AccordionDetails>
				</Accordion>
			)}

			{showConfig && (
				<Accordion expanded={true}>
					<AccordionDetails>
						<List component={"div"} style={{width: "100%"}}>
							<ConfigMenu/>
						</List>
					</AccordionDetails>
				</Accordion>
			)}
		</Box>

	);
}

export default SideBar;